/**
 * Live feedback, computed from the board alone (CLAUDE.md §10): the answer key never reaches
 * this code. Only what can no longer be right is flagged.
 */
import type { Feedback } from "../types";
import { resizeRows } from "./progress";
import { contradictions } from "./rules";
import { cellId, type AkariDefinition, type AkariProgress } from "./types";

const cellsOfKeys = (keys: Set<string>): string[] =>
  [...keys].map((k) => {
    const [r, c] = k.split(",").map(Number);
    return cellId(r, c);
  });

export function localFeedback(definition: AkariDefinition, progress: AkariProgress): Feedback[] {
  const marks = resizeRows(progress.rows, definition.rows, definition.cols);
  const found = contradictions(definition.grid, marks);
  const feedback: Feedback[] = [];
  if (found.bulbs.size > 0)
    feedback.push({ type: "bulb", code: "bulbs_see_each_other", cells: cellsOfKeys(found.bulbs) });
  if (found.dark.size > 0)
    feedback.push({ type: "cell", code: "cell_cannot_be_lit", cells: cellsOfKeys(found.dark) });
  if (found.numbers.size > 0)
    feedback.push({
      type: "number",
      code: "number_contradiction",
      cells: cellsOfKeys(found.numbers),
    });
  return feedback;
}
